module.exports = __webpack_public_path__ + "static/img/67.92169597.png";